import './XYChartOverlay.css';
export var overlay = '_ybpn9s0-2-0-1';